import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import './BrandOnboardingPanelTransition.scss';

const BrandOnboardingPanelTransition = ({ Panel, panelProps, isActive, onFadeOutEnd }) => {
  const node = useRef(null);
  const [mounted, setMounted] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (isActive) {
      setFadeOut(false); // <- reset
      setMounted(true);
    } else {
      timeoutId = setTimeout(() => setFadeOut(true), 100);
    }

    /* cleanup – kill timeout if props change before it fires */
    return () => clearTimeout(timeoutId);
  }, [isActive]);

  const handleEnd = e => {
    if (e.target !== node.current) return; // ignore child events
    if (!isActive) {
      setMounted(false);
      onFadeOutEnd?.();
    }
  };

  if (!mounted) return null;
  else if (!Panel) return null;

  return (
    <div ref={node} className={cn('brand-onboarding-panel-transition', { 'fade-out': fadeOut })} onTransitionEnd={handleEnd}>
      <Panel {...panelProps} />
    </div>
  );
};

export default BrandOnboardingPanelTransition;
